<template>
  <div class="package mb-0 d-flex align-items-center">
    <Select :options="actionOptions" :value="object.package" @changeValue="changeActionValue" placeholder="Package" :disabled="object?.default" />
    <component :is="subActionPackage" :config="subActionConfig" @changeValue="changeSubActionValue" :isSubAction="true" :disabled="object?.default" />
    <input type="text" :value="object.range" @change="changeActionRange" class="form-control" placeholder="Range" style="width: 200px" />
  </div>
</template>

<script>
import DefaultValue from './../DefaultValue.vue'
export default {
  extends: DefaultValue,
  components: {},
  computed: {
    actionPackages() {
      return this.more?.events?.[this.event]?.actions || []
    },
    actionOptions() {
      return (
        this.actionPackages.reduce((result, current) => {
          result.push({
            id: current,
            text: this.more?.action_packages?.[current]?.label
          })
          return result
        }, []) || []
      )
    },
    subActionPackage() {
      let packageName
      if (Object.keys(this.more?.action_packages).includes(this.object?.package)) {
        packageName = _.pascalCase(this.object.package)
      }
      return packageName ? `SubAction${packageName}` : null
    },
    subActionConfig() {
      let config = {
        action: _.cloneDeep(this.object),
        more: this.config.more
      }
      // config.parentPackage = this.object.package
      return config
    }
  },
  methods: {
    registerComponent({ name, type, path }) {
      path = `/views/Automation/Modal/${path}`
      if (!this.$options.components?.[`${type}${name}`]) {
        this.$options.components[`${type}${name}`] = this.$util.requireOrNull(`${path}/${name}Package.vue`) || this.$util.requireOrNull(`${path}/DefaultPackage.vue`)
      }
      return this.$options.components[`${type}${name}`]
    },
    changeActionValue(value) {
      this.$emit('changeValue', {
        field: 'package',
        value
      })
    },
    changeSubActionValue({ field, value }) {
      this.$emit('changeValue', {
        field,
        value
      })
    },
    changeActionRange(e) {
      this.$emit('changeValue', {
        field: 'range',
        value: e.target.value
      })
    }
  },
  watch: {
    actionPackages: {
      handler(values) {
        values.forEach((name) => {
          name = _.pascalCase(name)
          this.registerComponent({
            name,
            type: 'Action',
            path: 'Actions/Packages'
          })
        })
      },
      immediate: true
    },
    subActionPackage: {
      handler(name) {
        if (!name) return
        this.registerComponent({
          name: name ? name.replace(/SubAction/g, '') : null,
          type: 'SubAction',
          path: 'Actions/Packages'
        })
      },
      immediate: true
    }
  },
  props: {
    object: Object,
    config: Object
  }
}
</script>
